import { useState } from 'react';
import { CalendarIcon } from '@radix-ui/react-icons';

import { Button } from '@/components/ui/button';
import { Calendar } from '@/components/ui/calendar';
import { Popover, PopoverContent, PopoverTrigger } from '@/components/ui/popover';
import { useTranslation } from 'react-i18next';

const formatDate = (date: Date, locale: string = 'ro-RO'): string => {
  return date.toLocaleDateString(locale, {
    month: 'numeric',
    day: 'numeric',
    year: 'numeric',
  });
};

export interface TradingDatePickerProps {
  onUpdate?: (date: Date) => void;
  initialDate?: Date;
  locale?: string;
}

export const TradingDatePicker = ({
  onUpdate,
  initialDate = new Date(),
  locale = 'ro-RO',
}: TradingDatePickerProps) => {
  const [open, setOpen] = useState(false);
  const [date, setDate] = useState<Date | undefined>(initialDate);

  const { i18n } = useTranslation('translation', {
    keyPrefix: 'components.date_range_picker',
  });

  const formatButtonDate = (from?: Date) => {
    if (!from) return <span>Select a date</span>;

    return <span>{formatDate(from, locale)}</span>;
  };

  return (
    <Popover open={open} onOpenChange={setOpen}>
      <PopoverTrigger asChild>
        <Button variant="outline" className="justify-between gap-2 px-3 font-normal">
          <CalendarIcon className="size-4" />
          <div className="text-right">
            <div className="py-1">{formatButtonDate(date)}</div>
          </div>
        </Button>
      </PopoverTrigger>
      <PopoverContent className="w-auto overflow-hidden p-0" align="end">
        <Calendar
          localeDayPicker={i18n.language as 'ro' | 'en'}
          mode="single"
          selected={date}
          className="p-4"
          onSelect={(selected) => {
            if (selected) {
              setDate(selected);
              onUpdate?.(selected);
            }
            setOpen(false);
          }}
        />
      </PopoverContent>
    </Popover>
  );
};

export default TradingDatePicker;
